import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { guideTokens } from '../theme/guideTokens';

interface GuideSectionProps {
  id: string;
  title: string;
  lead?: string;
  hideTitle?: boolean;
  children: React.ReactNode;
}

export const GuideSection: React.FC<GuideSectionProps> = ({
  id,
  title,
  lead,
  hideTitle,
  children,
}) => {
  return (
    <Box
      component={motion.section}
      id={id}
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.28, ease: [0.16, 1, 0.3, 1] }}
      sx={{
        scrollMarginTop: 96,
        mb: 2,
      }}
    >
      {!hideTitle && (
        <>
          <Typography
            variant="h4"
            component="h2"
            sx={{
              fontFamily: guideTokens.fontDisplay,
              fontWeight: 800,
              fontSize: { xs: '1.5rem', sm: '1.75rem' },
              letterSpacing: '-0.03em',
              mb: lead ? 1 : 2,
            }}
          >
            {title}
          </Typography>
          {lead && (
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{
                mb: 3,
                maxWidth: 720,
                lineHeight: 1.7,
                fontSize: '1rem',
                fontFamily: guideTokens.fontBody,
              }}
            >
              {lead}
            </Typography>
          )}
        </>
      )}
      {children}
    </Box>
  );
};
